const initialState = {
  loading: false,
  organizations: [],
  featuredCampaigns: [],
  pagination: {
    pageNumber: 1,
    pageSize: 9
  },
  filter: {
    name: ''
  }
};

const organizationListings = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SEARCH_FILTER_FOR_ORGANIZATION_LISTINGS':
    case 'FOLLOW_COMPANY_ORGANIZATION_REQUEST':
    case 'FOLLOW_COMPANY_ORGANIZATION_SUCCESS':
    case 'FOLLOW_COMPANY_ORGANIZATION_FAILED':
    case 'SET_PAGINATION_FOR_ORGANIZATION_LISTINGS':
    case 'GET_ORGANIZATION_LISTINGS_REQUEST':
    case 'GET_ORGANIZATION_LISTINGS_SUCCESS':
    case 'GET_ORGANIZATION_LISTINGS_FAILED':
    case 'GET_FEATURED_CAMPAIGNS_FOR_ORGANIZATION_LISTINGS_REQUEST':
    case 'GET_FEATURED_CAMPAIGNS_FOR_ORGANIZATION_LISTINGS_SUCCESS':
    case 'GET_FEATURED_CAMPAIGNS_FOR_ORGANIZATION_LISTINGS_FAILED': {
      return {
        ...state,
        ...action.payload
      }
    }
    default: {
      return state;
    }
  }
};

export default organizationListings;
